export default "__VITE_ASSET__eJZ5mXML__"